import heroImage from "@/assets/heroSection.webp";
import bgImg from "@/assets/heroSectionBg.webp"
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate()
  return (
    <div className="relative w-full min-h-[95vh] md:min-h-[85vh]  flex justify-center items-center pt-28 overflow-hidden">
      {/* Background Image */}
      <img
        src={bgImg}
        alt="Background"
        className="absolute  top-0 left-0 w-full h-full object-fill z-0"
      />

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row justify-center items-center max-w-7xl w-full z-10 px-4 md:px-0 text-left">

        {/* Text Section */}
        <div className="w-full lg:w-[55%]  md:text-left mt-10 lg:mt-0">
          <h1 className="text-3xl  md:text-5xl font-semibold ">
            Smarter hiring   with
          </h1>
          <span className="text-[#7EB08A] text-3xl  md:text-5xl font-semibold mb-4 md:mb-6 leading-relaxed lg:leading-loose">AI Interviews</span>

          <p className="text-lg  lg:text-xl mb-8 md:mb-14 leading-7 md:leading-relaxed">
            Cut your time-to-hire by 70% with talentick.ai's end-to-end AI-automated interviews.

            Streamline your recruitment process and reduce manual tasks with accurate candidate evaluations.
          </p>
          <div className="mb-8">
            <button onClick={() => navigate("/register")} className="bg-black text-white text-md sm:text-lg px-8 sm:px-10 py-3 sm:py-4 rounded-full font-medium transition-all hover:scale-110">
              Get Started
            </button>

          </div>
        </div>

        {/* Hero Image */}
        <div className="w-full md:w-[65%] pt-8 md:pt-12">
          <img src={heroImage} alt="Hero" className="w-full h-auto" />
        </div>

      </div>
    </div>


  )
}

export default HeroSection;
